export default __webpack_public_path__ + "static/media/wa_icon.c79ebb39.svg";